module.exports = ".market_price {\n    margin-top: 10px;\n    margin-left: 48px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/new-offer/new-offer.component.css
// module id = ./src/app/new-offer/new-offer.component.css
// module chunks = main